// @flow

import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay/compat';
import JobEvent from '../JobEvent';
import type { JobEventScheduled_event } from './__generated__/JobEventScheduled_event.graphql';

type Props = {
  event: JobEventScheduled_event,
  previousTimestamp: ?string
};

function JobEventScheduled({ event, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>
        Dispatcher Scheduled Job
      </JobEvent.Label>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventScheduled, {
  event: graphql`
    fragment JobEventScheduled_event on JobEvent {
      ... on JobEvent {
        timestamp
      }
    }
  `
});

